import { useEffect } from "react";
import { useAPI } from "../api/useAPI";
import { NotesList } from "../note/NotesList";
import { AppPage } from "../utils/AppPage";

export const NotificationsPage = () => {
  const api = useAPI();
  useEffect(() => {
    api.clearNotifications();
  }, [api]);
  return (
    <AppPage title="Notifications">
      <NotesList />
    </AppPage>
  );
};
